export function formatMoney(value: number | string | null | undefined, currency = 'USD', digits = 6) {
  const amount = Number(value ?? 0)
  const maximumFractionDigits = digits
  const minimumFractionDigits = amount === 0 ? 2 : Math.min(2, digits)
  return `${new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount)} ${currency}`
}

export function formatSignedMoney(value: number | string, currency: string, digits = 6) {
  const amount = Number(value)
  const formatted = formatMoney(Math.abs(amount), currency, digits)
  if (amount > 0) return `+${formatted}`
  if (amount < 0) return `−${formatted}`
  return formatted
}
